<div class="position-relative">
  <div class="item-image">
    <!--Sponsor-->
    @if (marketplaceItem?.Sponsor?.SponsorImage) {
      <div class="corner-icon-container-sponsor">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="{{ marketplaceItem?.Sponsor?.SponsorLink }}"
          [attr.aria-label]="
            marketplaceItem?.Sponsor?.SponsorText + ' (' + ('fgbcl.accessibility.opens.new.tab' | translate) + ')'
          "
        >
          <img
            src="{{ marketplaceItem?.Sponsor?.SponsorImage | contentImage: '6' : 'marketplace' }}"
            [alt]="marketplaceItem?.Sponsor?.SponsorText"
          />
        </a>
      </div>
    }
    <!--Item Image-->
    <a
      [owlRouterLink]="'/rewards/marketplace/details/' + marketplaceItem.Id"
      [stopLink]="ignoreLink"
      [attr.aria-label]="marketplaceItem.DisplayName"
    >
      <div class="card loyalty border-0">
        <div>
          <img
            class="card-img-top"
            [src]="imageUrl | contentImage: '7' : 'marketplace'"
            alt=""
            [useDefault]="true"
            [loyaltyType]="'marketplace'"
            draggable="false"
          />
        </div>
      </div>
    </a>
  </div>

  <div class="rewards-item-panel-status">
    @switch (marketplaceItem.Status) {
      @case (marketplaceStatus.Favourite) {
        <span class="icon material-icons me-1 font-size-20 text-success" aria-hidden="true">{{ featuredIcon }}</span>

        <span class="item-state text-success">
          {{ 'marketplace.featured.stock' | translate }}
        </span>
      }
      @case (marketplaceStatus.ComingSoon) {
        <span class="item-state status-text-on-coming-soon">
          {{ 'marketplace.redeem.coming.soon' | translate }}
        </span>
      }
      @case (marketplaceStatus.ViewableOnly) {
        <span class="item-state text-info text-rewards-locked">
          <span class="icon material-icons rewards-locked-icon">lock</span>
          {{ 'reward.status.locked' | translate }}
        </span>
      }
      @case (marketplaceStatus.LimitedStock) {
        @if (marketplaceItem.StockCount <= 5) {
          <span class="item-state text-rewards-danger">
            {{ marketplaceItem.StockCount }} {{ 'marketplace.panel.remaining.stock' | translate }}
          </span>
        } @else {
          <span class="item-state text-rewards-danger">
            {{ 'marketplace.limited.stock' | translate }}
          </span>
        }
      }
      @case (marketplaceStatus.SoldOut) {
        <span class="item-state status-text-on-sold-out">
          {{ 'marketplace.redeem.sold.out' | translate }}
        </span>
      }
      @case (marketplaceStatus.LimitReached) {
        <span class="item-state status-text-on-limit-reached">
          {{ 'marketplace.redeem.member.limit' | translate }}
        </span>
      }
      @case (marketplaceStatus.NotEnoughPoints) {
        <span class="item-state status-text-on-not-enough-points">
          {{ 'marketplace.redeem.not.enough.points' | translate }}
        </span>
      }
      @case (marketplaceStatus.NewItem) {
        <span class="item-state text-rewards-new">
          {{ 'marketplace.new.stock' | translate }}
        </span>
      }
      @case (marketplaceStatus.LimitedItem) {
        @if (marketplaceItem.LimitType === 2) {
          <span class="item-state text-rewards-danger">
            {{ 'marketplace.account.limited' | translate }}
          </span>
        } @else {
          <span class="item-state text-rewards-danger">
            {{ 'marketplace.member.limited' | translate }}
          </span>
        }
      }
    }
  </div>
  <!--Item Name-->
  <div class="rewards-item-panel-name">{{ marketplaceItem.DisplayName }}</div>
  @if (marketplaceItem.Status !== marketplaceStatus.DisabledManualEntry) {
    @if (marketplaceItem.EcashValue || marketplaceItem.MerchantValue) {
      @if (marketplaceItem.EcashValue) {
        <label class="accessibility-only">{{ 'fgbcl.accessibility.ecash.value' | translate }}: </label>
        <div class="rewards-item-panel-value" id="ecash-value">{{ marketplaceItem.EcashValue / 100 | FortressCurrencyPipe }}</div>
      } @else if (marketplaceItem.MerchantValue) {
        <label class="accessibility-only">{{ 'fgbcl.accessibility.merchant.value' | translate }}: </label>
        <div class="rewards-item-panel-value" id="merchant-value">
          {{ marketplaceItem.MerchantValue / 100 | FortressCurrencyPipe }}
        </div>
      }
    } @else {
      @if (marketplaceItem.PointValue == 0) {
        <div *ngIf="marketplaceItem.PointValue == 0" class="rewards-item-panel-value">
          {{ 'fgbcl.marketplace.item.claim.now' | translate }}
        </div>
      } @else {
        <label class="accessibility-only">{{ 'fgbcl.accessibility.points.value' | translate }}: </label>
        <div *ngIf="marketplaceItem.PointValue > 0" class="rewards-item-panel-value">
          {{ marketplaceItem.PointValue | FortressCurrencyPipe: 'PTS' }}
        </div>
      }
    }
  }
</div>
